import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default abstract class DividendBaseCriteria extends Model.CriteriaBase {
    
    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.monthStart(DateUtils.today());

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.monthEnd(DateUtils.today());

    @Rules.Required()
    public entityId: number | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<DividendBaseCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Dividend Criteria";
    }
}